<script setup lang="ts">
import { computed } from 'vue'
import { Marked } from 'marked'
import { markedHighlight } from 'marked-highlight'
import hljs from 'highlight.js'
import Avatar from '../Avatar/Avatar.vue'
import type { MessageData } from './types'
import TypingMessage from '@/components/TypingMessage.vue'
import { cn } from '@/lib/utils'

const props = defineProps<MessageData>()

const marked = new Marked(
  markedHighlight({
    langPrefix: 'hljs language-',
    highlight(code, lang, _info) {
      const language = hljs.getLanguage(lang) ? lang : 'plaintext'
      return hljs.highlight(code, { language }).value
    },
  }),
)

const markdownToHtml = computed(() => {
  return marked.parse(props.messageContent ?? '')
})
</script>

<template>
  <div :class="cn('conversation-chat pt-[4px] pb-[4px]', props.isAfterMessage ? 'pt-[8px]' : '', props.isBeforeMessage ? 'pb-[8px]' : '', $attrs.class ?? '')" tabindex="-1">
    <div class="chat-wrapper">
      <Avatar v-if="!props.isReply || props.isLoadingMessage" :is-chat="true" :image-src="messageAvatar" />
      <div :class="cn('beeetle-comment', isReply ? 'float-right rounded-br-0 font-semibold text-white bg-[#a63700]' : 'text-black bg-[#ebebeb] rounded-tl-0')">
        <div tabindex="-1">
          <div class="chat-content">
            <TypingMessage v-if="isLoadingMessage" />
            <article v-else class="prose-widget m-0 p-0">
              <div v-html="markdownToHtml" />
            </article>
          </div>
        </div>
      </div>
    </div>

    <div />
  </div>
</template>
